import React, { Component } from 'react';
import StepFooter from '../StepFooter';
import PropTypes from 'prop-types';

class Step2 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      currentLevel: null,
      errorMessage: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.footerNext = this.footerNext.bind(this);
  }

  getErrorMessage (state) {
    let validationError = '';
    if (state.currentLevel === null) {
      validationError = 'Please select your current level';
    }
    return validationError;
  }

  footerNext (event) {
    let validationError = this.getErrorMessage(this.state);
    if (validationError) {
      event.preventDefault();
      this.setState({
        errorMessage: validationError
      });
    } else {
      this.props.handleNextClick({currentLevel: this.state.currentLevel});
    }
  }

  handleChange (event) {
    let state = this.state;
    state.currentLevel = Number(event.target.value);
    // update the error mesage if there already was one
    if (state.errorMessage) {
      state.errorMessage = this.getErrorMessage(this.state);
    }
    this.setState(state);
  }

  render () {
    return (
      <div className='registration__step' style={{'height': '640px'}}>
        <div className='registration__inner'>
          <p className='registration__step-indicator'>Step 2 of 4</p>
          <p className='kilo'>My current level is...</p>

          <ul className='form-fields form-fields--compact'>
            <li>
              <label className='control radio'>
                <input id='experience1' name='experience' type='radio' value='0'
                  checked={this.state.currentLevel === 0}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                No experience
                <span className='label-extra label-extra--always-show'>I have never signed, beside the odd word or letter</span>
              </label>
            </li>
            <li>
              <label className='control radio'>
                <input id='experience2' name='experience' type='radio' value='1'
                  checked={this.state.currentLevel === 1}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                Level 1
                <span className='label-extra label-extra--always-show'>
                  Have completed a Level 1 qualification or training course (For example, for frontline staff with basic BSL skills)
                </span>
              </label>
            </li>
            <li>
              <label className='control radio'>
                <input id='experience3' name='experience' type='radio' value='2'
                  checked={this.state.currentLevel === 2}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                Level 2
                <span className='label-extra label-extra--always-show'>
                  Have completed a Level 2 qualification or training course (For example, for a Teacher of the Deaf with intermediate BSL skills)
                </span>
              </label>
            </li>
            <li>
              <label className='control radio'>
                <input id='experience4' name='experience' type='radio' value='3'
                  checked={this.state.currentLevel === 3}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                Level 3+
                <span className='label-extra label-extra--always-show'>
                  Have completed a Level 3 qualification or training course (For example, for a college Communication support Work with advanced BSL skills)
                </span>
              </label>
            </li>
          </ul>
          <StepFooter
            handlePreviousClick={this.props.handlePreviousClick}
            handleNextClick={this.footerNext}
            errorMessage={this.state.errorMessage}
          />
        </div>
      </div>
    );
  }
}

Step2.propTypes = {
  handlePreviousClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired
};

export default Step2;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step2/index.js